import { render, staticRenderFns } from "./ChangeEmailSetPassword.vue?vue&type=template&id=372d5a76&"
import script from "./ChangeEmailSetPassword.vue?vue&type=script&lang=js&"
export * from "./ChangeEmailSetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports